// import React, { useEffect } from "react";
// import AutocompleteInput from "./components/autoCompleteInput";
// import FilterContainer from "./components/filterContainer";
// import { COLORS } from "~src/data/constant";
// import DateFilterContainer from "./components/dateFilter/dateFilterContainer";
// import moment from "moment";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import AddIcon from "@mui/icons-material/Add";

// function GlobalFilters({
//   provider,
//   setProvider,
//   providerLabel,
//   handleAddProvider,
//   providerIdx,
//   handleDeleteProvider,
//   displayDates,
//   setDisplayDates,
// }) {
//   const handleFilterChange = (event) => {
//     const fieldName = event.target.name;
//     const fieldValue = event.target.value;
//     const currentProvider = { ...provider[providerLabel] };
//     currentProvider[fieldName] = Array.isArray(fieldValue)
//       ? fieldValue
//       : [fieldValue];

//     const providerListCopy = { ...provider };
//     providerListCopy[providerLabel] = currentProvider;

//     setProvider(() => providerListCopy);
//   };

//   const handleDateChange = (event) => {
//     setDisplayDates(() => ({ startDate: null, endDate: null }));
//     const fieldName = event.target.name;
//     const fieldValueFrom = event.target.fromDate;
//     const fieldValueTo = event.target.toDate;

//     if (fieldName === "time-period") {
//       const currentProvider = { ...provider[providerLabel] };
//       currentProvider["transaction-fromdate"] = [
//         moment(fieldValueFrom, "YYYY-MM-DD").format("DD-MM-YYYY"),
//       ];

//       currentProvider["transaction-todate"] = [
//         moment(fieldValueTo, "YYYY-MM-DD").format("DD-MM-YYYY"),
//       ];

//       const providerListCopy = { ...provider };
//       providerListCopy[providerLabel] = currentProvider;

//       setProvider(() => providerListCopy);
//     } else {
//       const fieldValue = event.target.value;
//       const currentProvider = { ...provider[providerLabel] };
//       currentProvider[fieldName] = [
//         moment(fieldValue, "YYYY-MM-DD").format("DD-MM-YYYY"),
//       ];

//       const providerListCopy = { ...provider };
//       providerListCopy[providerLabel] = currentProvider;

//       setProvider(() => providerListCopy);
//     }
//   };

//   const inputFilters = [
//     { filtername: "group", placeholder: "Group" },
//     { filtername: "type", placeholder: "Type" },
//     { filtername: "name", placeholder: "Name" },
//     { filtername: "clinician-speciality", placeholder: "Speciality" },
//     { filtername: "clinician-name", placeholder: "Clinician" },
//   ];

//   return (
//     <div className="providers p-0 mb-2 w-100">
//       <div className="d-flex flex-row w-100 justify-content-between align-items-center pt-2 px-2">
//         <div
//           className="mt-2 dot"
//           style={{
//             backgroundColor:
//               COLORS.length > providerIdx ? COLORS[providerIdx] : COLORS[0],
//           }}
//         />

//         <div className="d-flex ms-2 mt-2 flex-grow-1">
//           {inputFilters.map((filter, index) => (
//             <AutocompleteInput
//               key={`autocomplete_${provider}_${index}`}
//               page="comparisons"
//               filtername={filter.filtername}
//               placeholder={filter.placeholder}
//               type="main"
//               setProvider={setProvider}
//               provider={provider[providerLabel]}
//               providerLabel={providerLabel}
//               providerList={provider}
//             />
//           ))}
//         </div>

//         <div
//           className="d-flex align-items-center ms-5 mb-1"
//           style={{ width: "40rem" }}
//         >
//           <div>
//             <FilterContainer
//               provider={provider[providerLabel]}
//               handleFilterChange={handleFilterChange}
//             />
//           </div>
//           <div>
//             <DateFilterContainer
//               provider={provider[providerLabel]}
//               handleDateChange={handleDateChange}
//               displayDates={displayDates}
//               setDisplayDates={setDisplayDates}
//             />
//           </div>
//           {providerIdx === 0 ? (
//             <AddIcon
//               color="primary"
//               style={{ cursor: "pointer" }}
//               onClick={() => handleAddProvider()}
//             />
//           ) : (
//             <DeleteOutlineIcon
//               color="primary"
//               style={{ cursor: "pointer" }}
//               onClick={() => handleDeleteProvider(providerLabel)}
//             />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default GlobalFilters;



















//code for linking dash
import React, { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom"; // Add useHistory
import AutocompleteInput from "./components/autoCompleteInput";
import FilterContainer from "./components/filterContainer";
import { COLORS } from "~src/data/constant";
import DateFilterContainer from "./components/dateFilter/dateFilterContainer";
import moment from "moment";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
 
function GlobalFilters({
  provider,
  setProvider,
  providerLabel,
  handleAddProvider,
  providerIdx,
  handleDeleteProvider,
  displayDates,
  setDisplayDates,
}) {
  const location = useLocation();
  const history = useHistory(); // For setting URL query parameter

  // Set provider name from navigation state on mount
  useEffect(() => {
    const providerName = location.state?.providerName;
    if (providerName) {
      const currentProvider = { ...provider[providerLabel] };
      currentProvider["name"] = [providerName]; // Set as array for AutocompleteInput
      const providerListCopy = { ...provider };
      providerListCopy[providerLabel] = currentProvider;
      setProvider(providerListCopy);

      // Set URL query parameter to sync with AutocompleteInput
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("provider-name", providerName);
      history.push({
        pathname: location.pathname,
        search: searchParams.toString(),
      });
    }
  }, [location.state, provider, providerLabel, setProvider, history, location.pathname, location.search]);

  const handleFilterChange = (event) => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;
    const currentProvider = { ...provider[providerLabel] };
    currentProvider[fieldName] = Array.isArray(fieldValue) ? fieldValue : [fieldValue];

    const providerListCopy = { ...provider };
    providerListCopy[providerLabel] = currentProvider;
 
    setProvider(() => providerListCopy);
  };
 
  const handleDateChange = (event) => {
    setDisplayDates(() => ({ startDate: null, endDate: null }));
    const fieldName = event.target.name;
    const fieldValueFrom = event.target.fromDate;
    const fieldValueTo = event.target.toDate;
 
    if (fieldName === "time-period") {
      const currentProvider = { ...provider[providerLabel] };
      currentProvider["transaction-fromdate"] = [
        moment(fieldValueFrom, "YYYY-MM-DD").format("DD-MM-YYYY"),
      ];
      currentProvider["transaction-todate"] = [
        moment(fieldValueTo, "YYYY-MM-DD").format("DD-MM-YYYY"),
      ];
 
      const providerListCopy = { ...provider };
      providerListCopy[providerLabel] = currentProvider;
 
      setProvider(() => providerListCopy);
    } else {
      const fieldValue = event.target.value;
      const currentProvider = { ...provider[providerLabel] };
      currentProvider[fieldName] = [
        moment(fieldValue, "YYYY-MM-DD").format("DD-MM-YYYY"),
      ];
 
      const providerListCopy = { ...provider };
      providerListCopy[providerLabel] = currentProvider;
 
      setProvider(() => providerListCopy);
    }
  };
 
  const inputFilters = [
    { filtername: "group", placeholder: "Group" },
    { filtername: "type", placeholder: "Type" },
    { filtername: "name", placeholder: "Name" },
    { filtername: "clinician-speciality", placeholder: "Speciality" },
    { filtername: "clinician-name", placeholder: "Clinician" },
  ];
 
  return (
    <div className="providers p-0 mb-2 w-100">
      <div className="d-flex flex-row w-100 justify-content-between align-items-center pt-2 px-2">
        <div
          className="mt-2 dot"
          style={{
            backgroundColor:
              COLORS.length > providerIdx ? COLORS[providerIdx] : COLORS[0],
          }}
        />
        <div className="d-flex ms-2 mt-2 flex-grow-1">
          {inputFilters.map((filter, index) => (
            <AutocompleteInput
              key={`autocomplete_${provider}_${index}`}
              page="comparisons"
              filtername={filter.filtername}
              placeholder={filter.placeholder}
              type="main"
              setProvider={setProvider}
              provider={provider[providerLabel]}
              providerLabel={providerLabel}
              providerList={provider}
            />
          ))}
        </div>
        <div className="d-flex align-items-center ms-5 mb-1" style={{ width: "40rem" }}>
          <div>
            <FilterContainer
              provider={provider[providerLabel]}
              handleFilterChange={handleFilterChange}
            />
          </div>
          <div>
            <DateFilterContainer
              provider={provider[providerLabel]}
              handleDateChange={handleDateChange}
              displayDates={displayDates}
              setDisplayDates={setDisplayDates}
            />
          </div>
          {providerIdx === 0 ? (
            <AddIcon color="primary" style={{ cursor: "pointer" }} onClick={() => handleAddProvider()} />
          ) : (
            <DeleteOutlineIcon
              color="primary"
              style={{ cursor: "pointer" }}
              onClick={() => handleDeleteProvider(providerLabel)}
            />
          )}
        </div>
      </div>
    </div>
  );
}
 
export default GlobalFilters;